import React, { useEffect, useState, useMemo, useContext } from "react";
import {
  getHeaderTemplateList,
  updateDefaultHeaderTemplate,
} from "../../../service/MasterService";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { t } from "i18next";
import TabContainer from "../../../components/TabContainer/TabContainer";
import CustomBreadCrumb from "../../../components/CustomBreadCrumb";
import HeaderTemplateTab from "./HeaderTemplateTab";
import HeaderTemplateValue from "./HeaderTemplateValue";
import CustomSpinner from "../../../components/CustomSpinner";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../../constants/Constants";
import ConfirmModal from "../../../components/Modal/ConfirmModal";
import {
  editFirmHeaderTemplate,
  listFirmHeaderTemplate,
} from "../../../service/FirmServices";
import userContext from "../../../context/users/UserContext";
import loaderContext from "../../../context/loader/LoaderContext";

const HeaderTemplate = (props) => {
  const isEnterprise =
    process.env.REACT_APP_ENTERPRISE_PLATFORM == true ||
    process.env.REACT_APP_ENTERPRISE_PLATFORM == "true"
      ? true
      : false;
  const { roles, loadByUsername, authenticated, firmId, userId, checkForUserAccess } =
    useContext(userContext);
  const [itemLength, setItemLength] = useState([]);
  const [loadingState, setLoadingState] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [headerList, setHeaderList] = useState([]);
  const [tabDetails, setTabDetails] = useState([]);
  const [selectedHTab, setSelectedHTab] = useState("");
  const [selectedUTab, setSelectedUTab] = useState("");
  const [isUpdate, setIsUpdate] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showTemplateConfirmModal, setShowTemplateConfirmModal] =
    useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [firmStudyReportId, setFirmStudyReportId] = useState(-1);
  const navigate = useNavigate();
  const action = props.state.action;
  const urlParams = new URLSearchParams(window.location.search);
  const clientId = urlParams.get("firmId");
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const [hovered, setHovered] = useState(false);
  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const fetchDefaultHeaderTemplateList = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await getHeaderTemplateList();
    console.log(response);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setLoading(false);
      let data = response.data.data.data.masterStudyReportList;
      setHeaderList(data);
      setItemLength(data.length);
      let tempList = [];
      tempList = data.map((item, index) => {
        if (item.defaultReport) {
          changeOpt(item.id);
        }
        return {
          selectedKey: index + 1,
          tabKeyContain: (
            <HeaderTemplateTab
              key={index + 1}
              orderNumber={index + 1}
              id={item.id}
              defaultReport={item.defaultReport}
              masterStudyReportId={
                item.masterStudyReportId ? item.masterStudyReportId : -1
              }
              selectedHTab={item.defaultReport ? item.id : ""}
              setSelectedHTab={setSelectedHTab}
              setSelectedUTab={setSelectedUTab}
              setShowTemplateModal={setShowTemplateModal}
              setShowConfirmModal={setShowConfirmModal}
            />
          ),
          tabValueContain: (
            <HeaderTemplateValue
              key={index + 1}
              report={item.report}
              id={item.id}
            />
          ),
          
        };
      });
      setTabDetails(tempList);
      setIsUpdate(1);
    } else {
      setLoading(false);
      setError(response);
    }
    ref.current.complete();
  };

  const fetchFirmHeaderTemplateList = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    let id = clientId != null ? clientId : firmId;
    const response = await listFirmHeaderTemplate(id);
    console.log(response);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setLoading(false);
      const masterStudyReportId = response.data.data.masterStudyReportId;
      setFirmStudyReportId(masterStudyReportId);
      let data = response.data.data.masterStudyReportList;
      setHeaderList(data);
      setItemLength(data.length);
      let tempList = [];
      tempList = data.map((item, index) => {
        if (masterStudyReportId == item.id) {
          changeOpt(item.id);
        }
        return {
          selectedKey: index + 1,
          tabKeyContain: (
            <HeaderTemplateTab
              key={index + 1}
              orderNumber={index + 1}
              id={item.id}
              defaultReport={item.defaultReport}
              masterStudyReportId={masterStudyReportId}
              selectedHTab={masterStudyReportId}
              setSelectedHTab={setSelectedHTab}
              setSelectedUTab={setSelectedUTab}
              setShowTemplateModal={setShowTemplateModal}
              setShowConfirmModal={setShowConfirmModal}
            />
          ),
          tabValueContain: (
            <HeaderTemplateValue
              key={index + 1}
              report={item.report}
              id={item.id}
            />
          ),
        };
      });
      console.log(tempList);
      setTabDetails(tempList);
      setIsUpdate(1);
    } else {
      setLoading(false);
      setError(response);
    }
    ref.current.complete();
  };

  // useEffect(()=>{
  //   console.log("callng useEffect");
  //   if(selectedHTab != "" && isUpdate === 1 && tabDetails.length > 1){
  //   let tempList = [];
  //         tempList = headerList.map((item, index) =>{
  //           return {
  //             selectedKey: index+1,
  //             // tabKeyContain: <HeaderTemplateTab key={index+1} orderNumber={index+1} id={item.id} defaultReport={item.defaultReport} masterStudyReportId={firmStudyReportId} selectedHTab={selectedHTab} setSelectedHTab={setSelectedHTab} setSelectedUTab={setSelectedUTab} setShowTemplateModal={setShowTemplateModal} setShowConfirmModal={setShowConfirmModal}/>,
  //             // tabValueContain: <HeaderTemplateValue key={index+1} report={item.report} id={item.id}/>,
  //             tabKeyContain: <p>Hello</p>,
  //             tabValueContain: <p>Hii</p>
  //           };
  //         });
  //         setTabDetails(tempList);
  //         console.log("templist", tempList);
  //       }
  // },[selectedHTab, isUpdate]);

  const changeOpt = (id) => {
    setSelectedHTab(id);
  };

  useEffect(() => {
    if (action === ACTIONS.ADD) {
      fetchDefaultHeaderTemplateList();
    } else if (action === ACTIONS.EDIT) {
      fetchFirmHeaderTemplateList();
    }
  }, [roles[0], action]);

  useEffect(() => {
    checkForUserAccess();
  }, [roles[0]]);

  const breadCrumbItems = [
    {
      text: t("heading.report-header-templates"),
      key: "headerTemplate",
    },
  ];

  const handleSelectedTemplate = () => {
    // setSelectedHTab(selectedUTab);
    setShowConfirmModal(false);
    setShowTemplateModal(false);
    if (action === ACTIONS.ADD) {
      handleSaveDefaultHeaderTemplate();
    } else {
      handleSaveHeaderTemplate();
    }
  };

  const handleNotSelectedTemplate = () => {
    setShowConfirmModal(false);
    setShowTemplateModal(false);
  };

  const handleSaveDefaultHeaderTemplate = async () => {
    console.log("handle save", selectedHTab);
    const response = await updateDefaultHeaderTemplate(selectedHTab);
    console.log(response);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      fetchDefaultHeaderTemplateList();
      setShowTemplateConfirmModal(true);
      setShowConfirmModal(true);
      setLoading(false);
    } else {
      setLoading(false);
      setError(response);
    }
  };

  const handleSaveHeaderTemplate = async () => {
    let payload = {
      firmId: clientId != null ? clientId : firmId,
      masterStudyReportId: selectedHTab,
    };
    const response = await editFirmHeaderTemplate(payload);
    console.log(response);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      fetchFirmHeaderTemplateList();
      setShowTemplateConfirmModal(true);
      setShowConfirmModal(true);
      setLoading(false);
    } else {
      setLoading(false);
      setError(response);
    }
  };

  const handleConfimFunc = () => {
    setShowTemplateConfirmModal(false);
    setShowConfirmModal(false);
  };

  return (
    <div className="main-container-body">
      {/* {showConfirmModal && showTemplateConfirmModal &&
      <ConfirmModal handleConfirm={handleConfimFunc} handleNotConfirm={handleConfimFunc} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={action===ACTIONS.ADD?t("confirm-message.select-default-header-template"):t("confirm-message.select-header-template")}
          title={t("confirm-message.confirm-title")} confirmButtonText={t("confirm-message.ok")}/>
    } */}
      {showConfirmModal && showTemplateModal && (
        <ConfirmModal
          handleConfirm={handleSelectedTemplate}
          handleNotConfirm={handleNotSelectedTemplate}
          setShowConfirmModal={setShowConfirmModal}
          showConfirmModal={showConfirmModal}
          message={
            action === ACTIONS.ADD
              ? t("confirm-message.select-confirm-default-header-template")
              : t("confirm-message.select-confirm-firm-header-template")
          }
          title={
            action === ACTIONS.ADD
              ? t("confirm-message.confirm-default-header-template")
              : t("confirm-message.confirm-header-template")
          }
          confirmButtonText={t("confirm-message.yes")}
        />
      )}
      {/* add ownfirm cond too -> pending */}
      {/* {isEnterprise?(roles[0]===USERTYPES.FIRMADMIN || roles[0] === USERTYPES.ADMIN):(roles[0]===USERTYPES.FIRMADMIN || roles[0]===USERTYPES.FIRMTECHNICIAN || roles[0]===USERTYPES.FIRMDOCTOR) &&  */}
      {tabDetails.length > 0 && (
        <>
          <TabContainer
            NoOfTabs={tabDetails.length}
            tabDetails={tabDetails}
            uniqueKey="headerTemplate_"
            previousNextButtons={false}
            onNextClick={() => console.log("Next clicked")}
            onEditClick={() => console.log("Next clicked")}
            state={{ action: "ADD" }}
            breadCrumbItems={breadCrumbItems}
            topButtons={[]}
          />
        </>
      )}
      {error && <p>{error}</p>}
    </div>
  );
};

export default HeaderTemplate;
